import { QueryReturnValue } from '@reduxjs/toolkit/dist/query';

export async function queryFile(args: QueryFileArgs): Promise<QueryReturnValue<File>> {
  const { baseQuery, url, params, defaultFilename, forceDefaultFilename } = args;

  const { data: blob, error, meta } = await baseQuery({
    url,
    params,
    responseHandler: (res) => res.blob(),
  });

  if (error) return { error };

  let filename = defaultFilename;

  const contentDisposition = meta.response.headers.get('Content-Disposition');
  if (contentDisposition && !forceDefaultFilename) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match?.[1]) filename = match[1];
  }

  return { data: new File([blob], filename!) };
}

interface QueryFileArgs {
  baseQuery: any;
  url: string;
  params?: URLSearchParams | Record<string, string>;
  defaultFilename?: string;
  forceDefaultFilename?: boolean;
}